// @flow
import each from '../utils/each';

import BasePlayer from '../players/base';
import StateEntity from '../state';

import BaseExtension from './base';
import ProgressExtension from './progress';
import PlayExtension from './play';
import VolumeExtension from './volume';
import FullScreenExtension from './fullscreen';
import ClosedCaptionsExtension from './cc';
import TOCExtension from './toc';
import AnnotationsExtension from './annotations';
import PosterExtension from './poster';
import PlaceholderExtension from './placeholder';
import ForwardExtension from './forward';
import BackwardExtensaion from './backward';
import DownloadExtension from './download';
import SettingsExtension from './settings';
// import HelpExtension from './help';
import ResizerExtension from './resizer';
import TitleExtension from './title';
import PrevExtension from './prev';
import NextExtension from './next';
import NextFrameExtensaion from './next-frame';
import PrevFrameExtensaion from './prev-frame';
import BufferingExtension from './buffering';
import MuxExtension from './mux';
import TheaterExtension from './theater';
import AudioTracksExtension from './audio-tarcks';
import CaptionSearchExtension from './caption-search';
// import C2PA from './c2pa';
import BottomNext from './bottom-next';
import BottomPrev from './bottom-prev';
import CrawlExtension from './crawl';
import LiveExtension from './live';
import ErrorExtension from './error';

import type { Player$ExtensionOptions } from '../types/Options';

const cond = [
   ['showTitle', TitleExtension],
   [true, BufferingExtension],
   ['showPoster', PosterExtension],
   ['showError', ErrorExtension],
   ['showBackward', BackwardExtensaion],
   ['showPrevFrame', PrevFrameExtensaion],
   ['showBottomPrev', BottomPrev],
   ['showPlay', PlayExtension],
   ['showBottomNext', BottomNext],
   ['showNextFrame', NextFrameExtensaion],
   ['showForward', ForwardExtension],
   ['showVolume', VolumeExtension],
   ['isLive', LiveExtension],
   ['showProgress', ProgressExtension],
   ['showAnnotations', AnnotationsExtension],
   ['showTheaterMode', TheaterExtension],
   ['showClosedCaptions', ClosedCaptionsExtension],
   ['showTOC', TOCExtension],
   ['showAudioTracks', AudioTracksExtension],
   ['showPlaceholder', PlaceholderExtension],
   ['showCaptionSearch', CaptionSearchExtension],
   ['showDownload', DownloadExtension],
   // ['showHelp', HelpExtension],
   ['showPrev', PrevExtension],
   ['showNext', NextExtension],
   ['useMux', MuxExtension],
   [true, ResizerExtension],
   // ['showC2PA', C2PA]
   ['showCrawl', CrawlExtension],
   ['showSettings', SettingsExtension], // must be last (except FullScreenExtension)
   ['showFullScreen', FullScreenExtension]
];

// eslint-disable-next-line
export default function extensions(player: BasePlayer, state: StateEntity, options: Player$ExtensionOptions): Array<BaseExtension> {
   const res = [];

   each(cond, ([ key, Extension ]) => {
      if (key === true || typeof key === 'string' && options[key] === true) {
         res.push(new Extension(player, state, options));
      }
   });

   return res;
}
